<p-toast position="top-right" key="roles-mgmt-message"></p-toast>
<p-menu #rolesMenu [model]="roleOptionMenu" [popup]="true"></p-menu>
<div class="p-mt-3">
    <p-breadcrumb [home]="home" [model]="breadcrumbMenuModel"></p-breadcrumb>

    <div class="card p-mt-3 p-shadow-4">

        <!--Roles Header-->

        <div class="p-grid p-ai-center divider-bottom">
            <div class="p-col-6">
                <h5 class="p-text-primary p-m-0"> Roles </h5>
            </div>

            <div class="p-col-6 p-text-right">
                <button pButton pRipple [icon]="'pi pi-plus'" (click)="navigateToAddRole()"
                        class="p-button-icon p-button-secondary"></button>
            </div>
        </div>

        <!--Loader/Spinner-->

        <div *ngIf="isLoading" class="p-d-flex p-ai-center p-jc-center" style="min-height: 400px">
            <div class="p-text-center">
                <div>
                    <i class="pi pi-spin pi-spinner p-text-secondary" style="font-size: 2rem"></i>
                </div>
                <div class="p-mt-3 p-text-secondary p-text-bold">
                    Loading Roles !
                </div>
            </div>
        </div>

        <!--If No Role is Found from DB-->

        <div *ngIf="paginatedRoles?.content?.length === 0 && !isLoading"
             class="p-d-flex p-ai-center p-jc-center" style="min-height: 400px">
            <div class="p-text-center p-mt-3 p-text-secondary p-text-bold">
                No Roles Found!
            </div>
        </div>

        <!--Roles Management-->

        <div *ngIf="paginatedRoles?.content?.length > 0 && !isLoading">

            <p-table class="user-data-table" [value]="paginatedRoles?.content">
                <ng-template pTemplate="body" let-role>
                    <tr class="p-text-left width-100 divider-bottom">
                        <td class="p-py-4">
                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                {{role?.name ? role?.name : '-'}}
                            </div>
                        </td>
                        <td style="width: 30px;">
                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                <i (click)="handleRoleOptionMenu($event, role)"
                                   class="pi pi-ellipsis-v p-text-primary p-text-bold p-cursor"
                                   style="font-size: 1.5rem;"></i>
                            </div>
                        </td>

                    </tr>
                </ng-template>
            </p-table>

        </div>

        <div class="p-mt-2">
            <p-paginator #rolePagination
                         (onPageChange)="paginateRoles($event)" [rows]="10"
                         [totalRecords]="paginatedRoles?.totalElements"></p-paginator>
        </div>

    </div>
</div>
